import axios from 'axios';


const formatDateToYYYYMMDD = (date: string) => {
  const dateObj = new Date(date);
  const year = dateObj.getUTCFullYear();
  const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const addPackageToCart = async (packageId: number, pricingModelId: number, dateRange: {startDate: string, endDate: string}) => {
  const sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    throw new Error('Session ID not found');
  }

  const formattedArrivalDate = formatDateToYYYYMMDD(dateRange.startDate);
  const formattedDepartureDate = formatDateToYYYYMMDD(dateRange.endDate);

  const payload = {
    packageId,
    pricingModelId,
    arrivalDate: formattedArrivalDate,
    departureDate: formattedDepartureDate,
    sessionId
  };

  console.log('Payload:', payload);

  try {
    const response = await axios.post<{ data: { data: any } }>(`${process.env.REACT_APP_API_URL}/ShoppingCart/addToPackageCart`, payload);
    console.log('Response:', response.data.data); // Log the response for debugging
    return response.data.data;
  } catch (error) {
    console.error('Error adding to cart:', error);
    return null;
  }
};

export const removePackageFromCart = async (sessionId: string, packageId: number, itemId: number) => {
  const url = `${process.env.REACT_APP_API_URL}/ShoppingCart/removeFromCart?sessionId=${sessionId}&packageId=${packageId}&itemId=${itemId}`;

  console.log('Removing item with URL:', url); // Log the URL for debugging

  try {
    const response = await fetch(url, {
      method: 'POST',
    });

    if (!response.ok) {
      throw new Error('Failed to remove item from cart');
    }

    const data = await response.json();
    console.log('Response:', data); // Log the response for debugging
    return data;
  } catch (error) {
    console.error('Error removing from cart:', error);
    return null;
  }
};








interface DateRange {
  startDate: string;
  endDate: string;
}

interface UnavailablePricingOption {
  startDate: string; // Change this to startDate
  endDate: string;   // Change this to endDate
  pricingModelId: number;
  description: string;
}

export const getUnavailablePricingOptions = async (packageId: number, dateRanges: DateRange[]) => {
  const startDate = dateRanges[0].startDate;
  const endDate = dateRanges[0].endDate;
  console.log('Calling API with:', { packageId, startDate, endDate });
  const response = await axios.get<{ data: UnavailablePricingOption[] }>(`${process.env.REACT_APP_API_URL}/shoppingcart/getUnavailablePricingOptions2`, {
    params: {
      packageId,
      startDate,
      endDate
    }
  });
  console.log('API Response:', response.data);
  return response.data;
};





